import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import {Container,CssBaseline,
    Grid,Button,Paper } from '@material-ui/core';
import omit from 'lodash/omit';
// import moment from 'moment';
import { useHistory,useParams,useLocation } from 'react-router-dom';

import { AppContext } from '../../App';
import axios from '../../utils/axios';
import util from '../../utils/util';

import validate from '../../utils/validate';
import constraint from '../../Constraints/ProductionBrique';
import MyTextField from '../Codification/MyTextField';
import MyDateField from '../Codification/MyDateField';
import MySelectField from '../Codification/MySelectField';

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(5),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }, 
}))
const initData = {
    date_operation:"",
    salaire:0,
    errors:{}
};
export default function Production(){
    const classes = useStyles();
    const history = useHistory();
    const { id } = useParams()
    const appContext = React.useContext(AppContext);
    const [production,setProduction] = React.useState({...initData})
    const [operations,setOperations] = React.useState([])
    const [typeBriques,setTypeBriques] = React.useState([])
    const [view,setView] = React.useState(false);
    const { pathname } = useLocation();
    const fetchData = async ()=>{
        appContext.setOpenLoading(true);
        try {
            const [operations,typeBriques] = await Promise.all([
                axios.get(`/operations-briqueteries`),
                axios.get(`/articles?nom=brique`),
            ]);
            if(id){
                const {data} = await axios.get(`/production-briques/${id}`);
                let production = {
                        id: data.id,
                        date_operation:data.date_operation,
                        operation:data.operation.id,
                        type_brique:data.type_brique.id,
                        quantite:data.quantite,
                        description: data.description,
                        errors:{}
                    }
                if(pathname===`/production-briques/view/${id}`){
                    setView(true);
                    production = {
                        ...production,
                        operation:data.operation,
                        type_brique:data.type_brique,

                    }
                }
                setProduction(production)
            }
            setOperations(operations.data.results)            
            setTypeBriques(typeBriques.data.results)            
        } catch (error) {
            console.log(error,error.response);
            appContext.addMessage(util.getContentError(error),'error');
        }
        appContext.setOpenLoading(false);
    }

    React.useEffect(()=>{
        fetchData();
        // eslint-disable-next-line
    },[]);
    const handleChange = (e)=>{
        setProduction({...production,[e.target.name]:e.target.value})
    }
    const enregistrer = async (nouveau)=>{
        const errors = validate(production,constraint.add);
        if(errors){
            setProduction({...production,errors});
            return;
        }
        try {
            appContext.setOpenLoading(true);
            await axios.post(`/production-briques`,{...omit(production,['errors'])});
            appContext.addMessage('Enregistrement effectué avec succès','success');
            if(nouveau){
                setProduction({...initData})
            }else{
                history.push("/liste-production-briques")
            }
        } catch (error) {
            console.log(error,error.response);
            appContext.addMessage(util.getContentError(error),'error');
        }    
        appContext.setOpenLoading(false);
    }
    const modifier = async ()=>{
        const errors = validate(production,constraint.add);
        if(errors){
            setProduction({...production,errors});
            return;
        }
        try {
            appContext.setOpenLoading(true);
            await axios.put(`/production-briques/${production.id}`,{...omit(production,['errors'])});
            appContext.addMessage('Modification effectué avec succès','success');
            history.goBack()
        } catch (error) {
            console.log(error,error.response);
            appContext.addMessage(util.getContentError(error),'error');
        }    
        appContext.setOpenLoading(false);
    }
    return (
        <Container component="main" maxWidth="md">
            <CssBaseline />
            <Paper className={classes.paper}>

                <Typography variant="h5" gutterBottom>
                    {id ? "Modification" : "Saisie"} Opération
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <MyDateField 
                            name="date_operation"
                            value={production.date_operation||""}
                            onChange={handleChange}
                            errors={production.errors}
                            label="Date operation"
                            disabled={view}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {view ?
                            <MyTextField 
                                name="operation"
                                value={production.operation && production.operation.date_operation}
                                label="Opération"
                                disabled={view}
                                required={false}
                            />
                        :
                            <MySelectField 
                                name="operation"
                                value={production.operation}
                                onChange={handleChange}
                                errors={production.errors}
                                options={operations}
                                libelle="date_operation"
                                disabled={view}
                                label="Opération"
                            />
                        }
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {view ?
                            <MyTextField 
                                name="type_brique"
                                value={production.type_brique && production.type_brique.nom}
                                label="Type brique"
                                disabled={view}
                                required={false}
                            />
                        :
                            <MySelectField 
                                name="type_brique"
                                value={production.type_brique}
                                onChange={handleChange}
                                errors={production.errors}
                                options={typeBriques}
                                libelle="nom"
                                disabled={view}
                                label="Type brique"
                            />
                        }
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <MyTextField 
                            inputProps={{
                                min:"0",
                                style:{textAlign:'right'}
                            }}
                            name="quantite"
                            type={view?"text":"number"}
                            value={view ? util.separteurMillier(production.quantite):production.quantite}
                            onChange={handleChange}
                            errors={production.errors}
                            label="Quantite"
                            disabled={view}
                            // style={{}}
                        />
                    </Grid>                                                                            
                   
                    <Grid item xs={12} sm={12}>
                        <MyTextField 
                            inputProps={{
                                min:"0",
                            }}
                            name="description"
                            value={production.description}
                            onChange={handleChange}
                            errors={production.errors}
                            label="Description"
                            multiline
                            rows="4"
                            variant="outlined"
                            disabled={view}
                            // required={false}
                        />
                    </Grid>
                    {id ?
                        <Grid item xs={12} sm={12}>
                            <Button
                                fullWidth
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={view?history.goBack:modifier}
                            >
                                {view ?'Retour':'Modifier'}
                            </Button>
                        </Grid>
                        :
                        <Grid container>
                            <Grid item xs={6} sm={6} style={{display:'flex', justifyContent:'center'}}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={()=>enregistrer(true)}
                                >
                                    Enregistrer & Nouveau
                                </Button>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={()=>enregistrer(false)}
                                >
                                    Enregistrer & Quitter
                                </Button>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Paper>
        </Container>
    )
};